export const BASE_API_URL = 'https://v1.api.icbt.impuls.id';

export const SEKOLAH_KODE = 'ul4ps1uns';
export const SEKOLAH_NAMA = 'ULAPSI UNS'
export const SEKOLAH_LOGO = 'https://storage.googleapis.com/storage.impuls.id/icbt/asset/ulapsi/logo.png';

export const THEME_COLOR = "#A41081"

export const BACKGROUND       = 'https://storage.googleapis.com/storage.impuls.id/icbt/asset/ulapsi/bg.jpg';
export const BACKGROUND_MINI  = 'https://storage.googleapis.com/storage.impuls.id/icbt/asset/ulapsi/bg-mini.jpg';